import { z } from 'zod';

export const WrikeTaskEvidenceSchema = z.object({
  id: z.string().min(1), taskId: z.string().min(1), title: z.string(), status: z.string(),
  folderIds: z.array(z.string().min(1)).min(1).max(100), assigneeIds: z.array(z.string().min(1)),
  collectedAt: z.string().datetime({ offset: true }), content: z.string(),
});
export type WrikeTaskEvidence = z.infer<typeof WrikeTaskEvidenceSchema>;
